import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";

import {_printNumber} from '../helpers/helpers.js'

interface TLD {
	TLD: string;
	DomainCount: number;
}

interface TLDLeadListProps {
	report?: string;
	name?: string;
	reporttype?: string;
	tlds?: TLD[];
}

export default function TLDLeadList({report, name, reporttype, tlds}: TLDLeadListProps) {

	if (!tlds) {
		return null
	}	
	if (tlds.length == 0) {
		return null
	}	

	return (
		<>
		<br/>
		<h4>Website Distribution by TLD</h4>
		Number of websites using {name}
		<table width="100%">
			<tbody>
			{
				tlds.map((tld: TLD, indexKey: number) => {
					return (
						<tr  key={indexKey}>
							<td width="40%">.{tld.TLD}</td>
							<td width="60%">	
							{
								(reporttype == 'none') &&
								<><b>{_printNumber(tld.DomainCount)}</b> websites
								</>
							}
							{
								(reporttype != 'none') &&
								<Link 
									className="link-hover word-break" 
									title={`Download Lead List`}									
									to = {`/create-report?${reporttype}=${report}&tld=${tld.TLD}`}
								>
									<b>{_printNumber(tld.DomainCount)}</b> websites
								</Link>		
							}							
							</td>							
						</tr>									
					)
				})
			}
			</tbody>			
		</table>
		</>
	)
}